﻿import * as React from 'react';

export function AdditionalProductIcon() {
    return (
        <i className="material-icons icon addAdditionalProduct__dropdownAdditionalProductButtonCameraIcon">
            add_a_photo
        </i>
    );
}
export function OrderPageAdditionalProductIcon(){
    return <i className="material-icons icon addAdditionalProduct__orderPageShowcaseAdditionalProductDisplayIcon"></i>
}
export function CameraIcon() {
    return (
        <i className="material-icons icon addAdditionalProduct__dropdownAdditionalProductButtonCameraIcon">
            photo_camera
        </i>
    );
}

export function CheckmarkIcon() {
    return (
        <i className="material-icons icon addAdditionalProduct__dropdownAdditionalProductButtonCheckmarkIcon">
            check
        </i>
    );
}

export function AddIcon() {
    return (
        <i className="material-icons addAdditionalProduct__dropdownAdditionalProductButtonAddIcon">
            add
        </i>
    );
}
